import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    SMEventMarketList: [],
    SMMarketList: [],
    SMBetsOfUser: [],
    SMBookData: [],
}

const SMSlice = createSlice({
    name: 'SMData',
    initialState: initialState,
    reducers: {
        saveEventMarketList: (state, action) => {
            state.SMEventMarketList = action.payload
        },
        saveMarketList: (state, action) => {
            state.SMMarketList = action.payload
        },
        saveBetsOfUser: (state, action) => {
            state.SMBetsOfUser = action.payload
        },
        saveSMBookData: (state, action) => {
            state.SMBookData = action.payload
        },
        resetSMData: (state) => {
            Object.assign(state, initialState);
        }
    }
})

export const { resetSMData, saveEventMarketList, saveMarketList, saveBetsOfUser, saveSMBookData } = SMSlice.actions;
export default SMSlice.reducer